import { useStores } from "@stores";
import type { TFunction } from "i18next";
import { useCallback, useState } from "react";

import { MarketListFilters } from "./MarketListFilters";
import { MarketListTable } from "./MarketListTable";

interface MarketListContentProps {
  t: TFunction<"translation", undefined>;
  navigate: (path: string) => void;
  onClose: () => void;
}

// NOT observer - only re-renders when user changes search/filter (state). Header and container stay stable.
export const MarketListContent = ({ t, navigate, onClose }: MarketListContentProps) => {
  const { marketStore } = useStores();
  const [showFavorites, setShowFavorites] = useState(false);
  const [search, setSearch] = useState("");

  const handleShowAll = useCallback(() => setShowFavorites(false), []);
  const handleShowFavorites = useCallback(() => setShowFavorites(true), []);

  const handleToggleFavorite = useCallback(
    (address: string) => {
      marketStore.toggleFavorite(address);
    },
    [marketStore],
  );

  const handleTokenSelectByAddr = useCallback(
    (marketAddr: string) => {
      const market = marketStore.allMarkets.find((m) => m.addr === marketAddr);
      if (market) {
        marketStore.setActiveMarket(market);
        navigate(`/trades/${market.symbol}`);
        onClose();
      }
    },
    [marketStore, navigate, onClose],
  );

  return (
    <>
      <MarketListFilters
        t={t}
        search={search}
        onSearchChange={setSearch}
        showFavorites={showFavorites}
        onShowAll={handleShowAll}
        onShowFavorites={handleShowFavorites}
      />

      <MarketListTable
        t={t}
        search={search}
        showFavorites={showFavorites}
        onSelect={handleTokenSelectByAddr}
        onToggleFavorite={handleToggleFavorite}
      />
    </>
  );
};
